/**
 * Return if user is logged in
 * Access token lives in Vuex store (in-memory). Lazy require prevents circular
 * dependency since router/index.js imports this file at module initialization time.
 */
export const isUserLoggedIn = () => {
  // eslint-disable-next-line global-require
  const store = require('@/store').default
  // return !!(localStorage.getItem('userData') && store.getters['auth/getAccessToken'])
  return !!localStorage.getItem('userData')
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

export const getUserRole = () => {
  if (getUserData()) {
    return getUserData().userRole;
  } 
  return null;
}

// Roles
export const Role = {
  Admin: 'Admin',
  TraitsAndHealth: 'TraitsAndHealth',
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === Role.Admin) return { name: 'manage-home' }
  if (userRole === Role.TraitsAndHealth) return { name: 'manage-homebase' }
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'login' }
}
